import { createFileRoute } from "@tanstack/react-router"

import { DesktopAnalytics } from "@/crm/components/analytics/desktop/analytics"
import { MobileAnalytics } from "@/crm/components/analytics/mobile/analytics"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/analytics")({
  component: AnalyticsRoute,
})

function AnalyticsRoute() {
  return <Adaptive desktop={<DesktopAnalytics />} mobile={<MobileAnalytics />} />
}
